var map = {
	"./en/app.json": 76309,
	"./en/auth.json": 3664,
	"./en/chat.json": 27236,
	"./en/chatList.json": 52492,
	"./en/chatbot.json": 61421,
	"./en/common.json": 46251,
	"./en/dashboard.json": 53198,
	"./en/dataGrid.json": 77590,
	"./en/errors.json": 25465,
	"./en/notifications.json": 9034,
	"./en/onboarding.json": 58095,
	"./en/products.json": 68634,
	"./en/profile.json": 34263,
	"./en/settings.json": 42815,
	"./en/settings_i18n.json": 22492,
	"./en/shell.json": 99300,
	"./en/themes.json": 14504,
	"./es/app.json": 32134,
	"./es/auth.json": 52285,
	"./es/chat.json": 13309,
	"./es/chatList.json": 77105,
	"./es/chatbot.json": 98534,
	"./es/common.json": 96266,
	"./es/dashboard.json": 53981,
	"./es/dataGrid.json": 56763,
	"./es/errors.json": 83180,
	"./es/notifications.json": 45261,
	"./es/onboarding.json": 61314,
	"./es/products.json": 70063,
	"./es/profile.json": 54424,
	"./es/settings.json": 85582,
	"./es/settings_i18n.json": 58087,
	"./es/shell.json": 53299,
	"./es/themes.json": 84973,
	"./it/app.json": 54091,
	"./it/auth.json": 73778,
	"./it/chat.json": 31922,
	"./it/chatList.json": 1078,
	"./it/chatbot.json": 78423,
	"./it/common.json": 68669,
	"./it/dashboard.json": 60164,
	"./it/dataGrid.json": 16192,
	"./it/errors.json": 51807,
	"./it/notifications.json": 24612,
	"./it/onboarding.json": 24333,
	"./it/products.json": 1956,
	"./it/profile.json": 79633,
	"./it/settings.json": 97385,
	"./it/settings_i18n.json": 86978,
	"./it/shell.json": 90158,
	"./it/themes.json": 87486,
	"./pt-BR/app.json": 18669,
	"./pt-BR/auth.json": 67784,
	"./pt-BR/chat.json": 46812,
	"./pt-BR/chatList.json": 91076,
	"./pt-BR/chatbot.json": 9317,
	"./pt-BR/common.json": 71907,
	"./pt-BR/dashboard.json": 14182,
	"./pt-BR/dataGrid.json": 61774,
	"./pt-BR/errors.json": 95473,
	"./pt-BR/notifications.json": 59378,
	"./pt-BR/onboarding.json": 85991,
	"./pt-BR/products.json": 30098,
	"./pt-BR/profile.json": 80543,
	"./pt-BR/settings.json": 18983,
	"./pt-BR/settings_i18n.json": 11252,
	"./pt-BR/shell.json": 37420,
	"./pt-BR/themes.json": 24976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77608;